import { motion } from "framer-motion";
import { ArrowUpRight, Instagram } from "lucide-react";

const links = [
  { label: "About", href: "#method" },
  { label: "Gallery", href: "#gallery" },
  { label: "Programs", href: "#programs" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-[1600px] mx-auto flex items-center justify-between px-5 md:px-10 h-16 md:h-20">
        <a href="#top" data-testid="header-logo-link" className="flex items-center gap-3">
          <img
            src="/assets/osh-logo.jpeg"
            alt="OSHPerformance logo"
            className="h-10 md:h-12 w-auto object-contain"
            data-testid="header-logo"
          />
        </a>
        <nav className="hidden md:flex items-center gap-10" data-testid="header-nav">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-display uppercase tracking-[0.2em] text-sm text-zinc-400 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a
            href="https://instagram.com/_oshperformance"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-instagram-link"
            aria-label="OSHPerformance on Instagram"
            className="text-zinc-400 hover:text-gold transition-colors duration-300"
          >
            <Instagram className="w-5 h-5" />
          </a>
          <a
            href="#contact"
            data-testid="header-consultation-btn"
            className="group inline-flex items-center gap-2 bg-gold text-black font-display font-semibold uppercase tracking-[0.15em] text-sm px-5 py-2.5 hover:bg-gold-bright transition-colors duration-300"
          >
            Book Consultation
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </motion.header>
  );
}
